import { Globals } from 'csstype'

import { css } from '@/styledComponents'
import { ArrayOr } from '@/types/common'

import { mediaQuery } from './media-query'
import { padPx } from './units'

/** @deprecated */
export interface FlexProps {
	justify?: Globals | React.CSSProperties['justifyContent'] | 'left' | 'normal' | 'right'
	justifySelf?:
		| Globals
		| React.CSSProperties['justifySelf']
		| 'auto'
		| 'baseline'
		| 'left'
		| 'normal'
		| 'right'
		| 'stretch'
	align?: Globals | React.CSSProperties['alignItems'] | 'baseline' | 'normal' | 'stretch'
	alignSelf?: Globals | React.CSSProperties['alignSelf'] | 'auto' | 'baseline' | 'normal' | 'stretch'
	direction?: React.CSSProperties['flexDirection']
	display?: Globals | React.CSSProperties['display'] | 'contents' | 'list-item' | 'none'
	wrap?: React.CSSProperties['flexWrap']
	gap?: React.CSSProperties['gap']
}

/** @deprecated */
export interface GridProps extends Omit<FlexProps, 'direction' | 'gap'> {
	columns?: ArrayOr<string | number>
	rows?: ArrayOr<string | number>
	gap?: ArrayOr<string | number>
	areas?: string
	template?: string
	templateAreas?: string | string[] | string[][]
	collapse?: boolean
	autoColumns?: ArrayOr<string | number>
	autoRows?: ArrayOr<string | number>
	justifyItems?: 'start' | 'end' | 'center' | 'stretch'
	alignItems?: 'start' | 'end' | 'center' | 'stretch' | 'baseline'
}

/** @deprecated */
export function flexLike({
	justify,
	align,
	direction = 'row',
	display,
	justifySelf,
	alignSelf,
	wrap,
	gap,
}: FlexProps & { display?: React.CSSProperties['display'] } = {}) {
	return `
		${display ? `display: ${display};` : ''}
		${display === 'flex' ? `flex-direction: ${direction};` : ''}
		${justify ? `justify-content: ${justify};` : ''}
		${align ? `align-items: ${align};` : ''}
		${justifySelf ? `justify-self: ${justifySelf};` : ''}
		${alignSelf ? `align-self: ${alignSelf};` : ''}
		${alignSelf ? `-webkit-align-self: ${alignSelf};` : ''}
		${wrap ? `flex-wrap: ${wrap};` : ''}
		${gap ? `gap: ${padPx(gap)};` : ``}
	`
}

/** @deprecated */
export function flex(options: FlexProps = {}) {
	return flexLike({ display: 'flex', ...options })
}

/** @deprecated */
export function grid({ gap: flexGap, ...options }: GridProps = {}) {
	const columns = options.columns
		? Array.isArray(options.columns)
			? options.columns.map(padPx).join(' ')
			: typeof options.columns === 'number'
				? new Array(options.columns).fill('1fr').join(' ')
				: padPx(options.columns)
		: null

	const rows = options.rows
		? Array.isArray(options.rows)
			? options.rows.map(padPx).join(' ')
			: padPx(options.rows)
		: null

	const gap = flexGap ? (Array.isArray(flexGap) ? flexGap.map(padPx).join(' ') : padPx(flexGap)) : null

	const templateAreas = options.templateAreas
		? Array.isArray(options.templateAreas)
			? (options.templateAreas as Array<string | string[]>)
					.map((area) => (Array.isArray(area) ? `"${area.join(' ')}"` : `"${area}"`))
					.join(' ')
			: options.templateAreas
		: null

	const autoColumns = options.autoColumns
		? Array.isArray(options.autoColumns)
			? options.autoColumns.map(padPx).join(' ')
			: padPx(options.autoColumns)
		: null

	const autoRows = options.autoRows
		? Array.isArray(options.autoRows)
			? options.autoRows.map(padPx).join(' ')
			: padPx(options.autoRows)
		: null

	return css`
		${() => flexLike({ ...options, display: 'grid' })};
		${columns ? `grid-template-columns: ${columns};` : ''};
		${rows ? `grid-template-rows: ${rows};` : ''};
		${gap ? `gap: ${gap};` : ''};
		${options.collapse ? mediaQuery.mobileOnly`grid-template-columns: 1fr;`.join('') : ''};
		${options.template ? `grid-template: ${options.template};` : ''};
		${templateAreas ? `grid-template-areas: ${templateAreas};` : ''};
		${autoColumns ? `grid-auto-columns: ${autoColumns};` : ''};
		${autoRows ? `grid-auto-rows: ${autoRows};` : ''};
		${options.justifyItems ? `justify-items: ${options.justifyItems};` : ''};
		${options.alignItems ? `align-items: ${options.alignItems};` : ''};
	`
}
